export function IsDemInfos(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.getDemInfoView !== undefined;
}
//# sourceMappingURL=dem.interfaces.js.map